import { MAX_CHAR_LENGTH } from '../constants/common';
import { DISABLED_CHARS } from '../constants/regex';

export const cleanWord = (word: string) =>
  word
    .trimStart()
    .replace(DISABLED_CHARS, '')
    .replace(/\s\s+/g, ' ') // replace multiple spaces with one space
    .slice(0, MAX_CHAR_LENGTH);
